import axios from 'axios';

// instance to connect with SULU app
// https://github.azc.ext.hp.com/3DSoftware/sulu
export const suluInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// instance to connect with 3daas-inventory app
// https://github.azc.ext.hp.com/3DSoftware/3daas-inventory
const storedData = localStorage.getItem('subscription');
let subscription = { token: null };

if (storedData) {
  subscription = JSON.parse(storedData);
}

export const inventoryInstance = axios.create({
  baseURL: process.env.REACT_APP_INVENTORY_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${subscription.token}`,
  },
});

suluInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = process.env.REACT_APP_REDIRECT_HOST;
    }

    return Promise.reject(error);
  }
);
